var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{style:({maxHeight: _vm.maxHeightElement +'px'})},_vm._l((_vm.merchants),function(merchantOne,i){return _c('ListShopsItem',{key:i,attrs:{"merchant":merchantOne}})}))}
var staticRenderFns = []

export { render, staticRenderFns }